import React, {useState} from 'react'
import {NavLink} from 'react-router-dom'

import styles from './Navigation.module.scss'
import {NavDropdown} from 'react-bootstrap'


export default function Navigation(props) {
    const [display, setDisplay] = useState()

    const handleMouseOver = (index) => {
        setDisplay(index)
    }

    // A dropdown stays shown while any of its descendants is the hovered one,
    // since navKey paths are built as parent keys joined with '-' (e.g. "3-0").
    const isOpen = (navKey) => display === navKey || display?.startsWith(`${navKey}-`)

    let generateNavigationLinks = (pages, isChild, keyPrefix = '',firstItem= true) => {
        // The first item needs special style to align as it will be a link not a menu toggle
        return pages.map((page, index) => {
            const {to, title, children} = page
            const navKey = `${keyPrefix}${index}`
            return children ?
                <NavDropdown
                    // onMouseEnter (not onMouseOver) - onMouseOver bubbles, so
                    // hovering a nested item would also re-fire this handler on
                    // every ancestor dropdown and clobber the deeper navKey.
                    onMouseEnter={() => handleMouseOver(navKey)}
                    onMouseLeave={() => handleMouseOver()}
                    show={isOpen(navKey)}
                    key={index}
                    className={styles.dropdown + ` ${isChild ? styles.child : ''}`} title={title}
                    id='navbarScrollingDropdown'>
                    <ul className={isChild && styles.dropdownChild}>{generateNavigationLinks(children, true, `${navKey}-`,false)}</ul>
                </NavDropdown>
                : <li key={index} style={firstItem ? {position:'relative',top:'5px'}: {}}><NavLink to={to} className={({isActive}) => isActive ? styles.active : undefined}>{title}</NavLink></li>
        })
    }

    return (
        <ul className={styles.Navigation}>
            {generateNavigationLinks(props.pages)}
        </ul>

    )
}
